import { Component, input } from '@angular/core';
import { IEventInfoOrderBm } from '@outlook-addin/cue-http';
import { translation } from '@cue/translations';
import { cueArrowDown, IconComponent } from '@cue/ui/icons';

import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'addin-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
  imports: [TranslocoPipe, IconComponent],
})
export class OrderDetailComponent {
  ICONS = {
    cueArrowDown,
  };
  translation = translation;

  shrinkItemIndexList: number[] = [];
  orderList = input<IEventInfoOrderBm[]>();

  isItemShrinked(itemIndex: number) {
    return this.shrinkItemIndexList.indexOf(itemIndex) > -1;
  }

  expandShrinkGroup(itemIndex: number) {
    const itemIxdInList = this.shrinkItemIndexList.indexOf(itemIndex);
    if (itemIxdInList > -1) {
      this.shrinkItemIndexList.splice(itemIxdInList, 1);
    } else {
      this.shrinkItemIndexList.push(itemIndex);
    }
  }
}
